import ReducerRegistry from '../base/redux/ReducerRegistry';
import { SET_PIP_ACTIVE, SET_PIP_WINDOW } from './actionTypes';
/**
 * The default state for the pip feature.
 */
const DEFAULT_STATE = {
    isPiPActive: false,
    pipWindow: null
};
/**
 * Reduces the Redux actions of the pip feature.
 */
ReducerRegistry.register('features/pip', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case SET_PIP_ACTIVE:
            return {
                ...state,
                isPiPActive: action.isPiPActive
            };
        case SET_PIP_WINDOW:
            return {
                ...state,
                pipWindow: action.pipWindow
            };
        default:
            return state;
    }
});
